<template>
    <button
        type="button"
        class="form-button"
        :disabled="disabled"
        v-on="$listeners"
    >
        <slot>
            <i v-if="isLoading && ! isCompleted" class="form-button-icon far fa-spinner fa-spin" />
            <i v-if="isCompleted && ! isLoading" class="form-button-icon far fa-check" />
            <i
                v-if="!! icon && ! isLoading && ! isCompleted"
                :class="[ 'form-button-icon', 'far', `fa-${icon}` ]"
            />
            <span class="form-button-text">{{ text }}</span>
        </slot>
    </button>
</template>
<script>
export default {
    props: {
        icon: {
            default: null,
            type: String,
        },

        text: {
            default: '',
            type: String,
        },

        disabled: {
            type: Boolean,
            default: false,
        },

        isLoading: {
            default: false,
            type: Boolean,
        },

        isCompleted: {
            default: false,
            type: Boolean,
        },
    },
};
</script>
